import React from 'react';

import { Surface } from '@infoods/lifebase-ui';
import LightbulbOutlineIcon from '@mui/icons-material/LightbulbOutline';

import classes from './InsightsWidget.module.scss';
import { WidgetTitle } from '../../components/WidgetTitle/WidgetTitle';
import { useDailyInsights } from './hooks/useDailyInsights';
import {
  SOLUTION_TYPE,
  SolutionType,
} from '../../../shared/constants/user-info/solutionType';

type InsightsWidgetProps = {
  solutionType: SolutionType;
};

const widgetTitle: Record<SolutionType, string> = {
  [SOLUTION_TYPE.NUTRITION]: 'Tip of the Day',
  [SOLUTION_TYPE.SCAN_IQ]: 'InBody Insights',
  [SOLUTION_TYPE.CHALLENGE]: '',
};

const InsightsWidget = ({ solutionType }: InsightsWidgetProps) => {
  const dailyInsights = useDailyInsights(solutionType);
  return (
    <Surface radius="l" className={classes.container}>
      <WidgetTitle
        title={widgetTitle[solutionType]}
        icon={<LightbulbOutlineIcon fontSize="small" />}
      />
      {dailyInsights && (
        <div className={classes.content}>
          <div>
            <p className={classes.title}>{dailyInsights.title}</p>
            <p className={classes.text}>{dailyInsights.description}</p>
          </div>
          {dailyInsights.howToImprove && (
            <div>
              <p className={classes.text}>How to improve it:</p>
              <p className={classes.improveText}>{dailyInsights.howToImprove}</p>
            </div>
          )}
        </div>
      )}
    </Surface>
  );
};

export { InsightsWidget };
